<div class="gd-chip-list tw-flex tw-flex-wrap">
  @for (item of preparedData && preparedData.visibleChips; track item) {
  <div class="gd-chip-list__chip"
       [class.--primary]="item.isPrimaryTaxonomy"
       [class.--secondary]="!item.isPrimaryTaxonomy"
       [class.--deactivated]="resourceType === ResourceType.Taxonomy && !item.active"
       [matTooltip]="item.fullPath"
       [matTooltipDisabled]="resourceType === ResourceType.Taxonomy && !item.active"
       [class.--locked]="resource.locked"
       [style.maxWidth]="width"
       [style.fontSize]="fontSize">
    @if (resourceType === ResourceType.Taxonomy && !item.active) {
    <mat-icon class="gd-chip-list__deactivated-taxonomy-icon"
              svgIcon="glideCustomIcon_deactivatedTaxonomies"
              matTooltip="Deactivated Taxonomy"
              i18n-matTooltip>
    </mat-icon>
    }
    <div class="gd-chip-list__chip-name">
      @for (name of item.displayData; track name; let last = $last; let first = $first) {
      <span [dir]="dir$ | async">
        @if (!first) {
        <mat-icon class="gd-chip-list__arrow-taxonomy-icon"
                  fontSet="fal"
                  [fontIcon]="(dir$ | async) !== 'rtl' ? 'fa-angle-right' : 'fa-angle-left'"> </mat-icon>
        }
        @if (name === 'NODE_PLACEHOLDER') {
        <mat-icon class="gd-chip-list__arrow-taxonomy-icon"
                  fontSet="fal"
                  fontIcon="fa-ellipsis-h-alt">
        </mat-icon>
        }
        @if (name !== 'NODE_PLACEHOLDER') {
        <span>{{ name }}</span>
        }
      </span>
      }
    </div>
  </div>
  }
  @if (!!preparedData?.infoChip && preparedData.hiddenChips.length) {
  <div class="gd-chip-list__chip --unshown-chips"
       [style.fontSize]="fontSize"
       [gdCheckMoreTooltip]="{type: resourceType, data: preparedData && preparedData.hiddenChips}">
    {{ preparedData.infoChip.name }}
  </div>
  }
</div>
